import type { ReactNode } from 'react';
import { ProgressBar } from '../atoms/ProgressBar.js';
import { LanguageSwitcher } from '../atoms/LanguageSwitcher.js';

interface InterviewLayoutProps {
  title?: string;
  currentStep?: number;
  totalSteps?: number;
  children: ReactNode;
}

export function InterviewLayout({
  title = 'PulseAgent',
  currentStep,
  totalSteps,
  children,
}: InterviewLayoutProps) {
  return (
    <div className="flex h-dvh flex-col bg-neutral-50">
      {/* Header */}
      <header className="shrink-0 border-b border-neutral-200 bg-white px-4 py-3">
        <div className="mx-auto flex max-w-2xl items-center justify-between">
          <h1 className="text-lg font-semibold text-neutral-800">{title}</h1>
          <div className="flex items-center gap-3">
            {currentStep != null && totalSteps != null && totalSteps > 0 && (
              <span className="text-sm text-neutral-500">
                {currentStep}/{totalSteps}
              </span>
            )}
            <LanguageSwitcher />
          </div>
        </div>
        {currentStep != null && totalSteps != null && totalSteps > 0 && (
          <div className="mx-auto mt-2 max-w-2xl">
            <ProgressBar value={currentStep} max={totalSteps} />
          </div>
        )}
      </header>

      {/* Main content */}
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <div className="mx-auto flex w-full max-w-2xl flex-1 flex-col overflow-hidden px-4 py-6">
          {children}
        </div>
      </main>
    </div>
  );
}
